import { TextField, styled } from '@mui/material';
import { PinnacleTextFieldProps } from './PinnacleTextField.types';

const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'invalidEmail'
})<PinnacleTextFieldProps>(({ theme, invalidEmail, variant, value }) => ({
  width: '100%',

  '& .MuiInputBase-input': {
    fontSize: '14px',
  },

  '& .MuiInputLabel-root': {
    color: '#fff',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#fff',
  },
  '& .MuiInputLabel-root.Mui-error': {
    color: '#ff4d4d',
  },
  '& .MuiFormHelperText-root': {
    backgroundColor: 'transparent',
    color: '#fff',
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: '#ff4d4d',
  },

  ...(invalidEmail && {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#ff4d4d',
      },
      '&:hover fieldset': {
        borderColor: '#ff4d4d',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#ff4d4d',
      },
    },
  }),

  // Variant: filled
  ...(variant === 'filled' && {
    '& .MuiInputBase-root': {
      backgroundColor: '#454545',
      '& input': {
        color: '#fff',
        backgroundColor: '#454545',
      },
      '&:hover': {
        backgroundColor: '#454545',
      },
      '&.Mui-focused': {
        backgroundColor: '#454545 !important',
      },
    },
    '& .MuiInputAdornment-root': {
      backgroundColor: '#454545',
      '&:hover': {
        backgroundColor: '#454545',
      },
    },
  }),

  // Variant: outlined
  ...(variant === 'outlined' && {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: invalidEmail ? '#ff4d4d' : value ? '#A8A8A8' : '#373737',
      },
      '&:hover fieldset': {
        borderColor: invalidEmail ? '#ff4d4d' : value ? '#A8A8A8' : '#373737',
      },
      '&.Mui-focused fieldset': {
        borderColor: invalidEmail ? '#ff4d4d' : value ? '#A8A8A8' : '#373737',
      },
      '&.Mui-disabled fieldset': {
        borderColor: '#373737',
      },
      '& input': {
        color: '#fff',
      },
      '&.Mui-disabled input': {
        color: '#5E5D5D',
        WebkitTextFillColor: '#5E5D5D',
      },
    },
    '& .MuiInputLabel-root': {
      color: '#fff',
    },
    '& .MuiInputLabel-root.Mui-disabled': {
      color: '#fff',
    },
  }),

  'label:not([data-shrink=true])+.MuiInputBase-formControl': {
    'input::-webkit-input-placeholder': {
      opacity: '0 !important',
    },
  },
}));

export default StyledTextField;
